import { Box, Button, Dialog, makeStyles } from "@material-ui/core";

interface Props {
  open: boolean;
  message: string;
  confirmButtonLabel: string;
  cancelButtonLabel: string;
  onConfirm: () => void;
  onCancel: () => void;
}

const useStyles = makeStyles(theme => ({
  dialogBox: {
    display: 'flex',
    flexDirection: 'column',
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    paddingBottom: theme.spacing(2)
  },
  button: {
    marginTop: theme.spacing(1)
  }
}));


const ActionConfirmationDialog = (props: Props) => {
  const classes = useStyles();

  const handleConfirmButtonClicked = () => {
    props.onConfirm();
    props.onCancel();
  };

  return (
    <Dialog open={props.open}>
      <Box className={classes.dialogBox}>
        <h2>{props.message}</h2>
        <Button
          color='primary'
          className={classes.button}
          onClick={handleConfirmButtonClicked}
          variant='contained'>
            {props.confirmButtonLabel}
        </Button>
        <Button
         color='secondary'
         className={classes.button}
         onClick={props.onCancel}
         variant='contained'>
           {props.cancelButtonLabel}
        </Button>
      </Box>
    </Dialog>
  );
};

export default ActionConfirmationDialog;